const DUPLICATE_HTTP_SCHEME = /^https?:\/\/(?=https?:\/\/)/i
const ALLOWED_SCHEME = /^(https?:\/\/|mailto:|tel:)/i
const EXPLICIT_SCHEME = /^[a-z][a-z\d+.-]*:\/\//i

/**
 * Turns what an admin typed or pasted into the rich text link field into a usable href: trims it,
 * drops a doubled `https://` prefix (pasting a full URL after a pre-typed `https://`), and adds
 * `https://` to a bare domain. Only http(s), mailto and tel links are allowed. Returns an empty
 * string for blank input or any other explicit scheme (e.g. `javascript://`).
 */
export const normalizeLinkUrl = (rawUrl: string): string => {
  let url = rawUrl.trim()

  while (DUPLICATE_HTTP_SCHEME.test(url)) {
    url = url.replace(DUPLICATE_HTTP_SCHEME, '')
  }

  if (!url || /^https?:\/\/$/i.test(url)) {
    return ''
  }

  if (ALLOWED_SCHEME.test(url)) {
    return url
  }

  if (EXPLICIT_SCHEME.test(url)) {
    return ''
  }

  return `https://${url}`
}
